import Icon from 'Components/Base/Icon'
import { useAppSelector } from 'hooks/hooks'
import usePatientIntake from 'hooks/usePatientIntake'
import React, { useEffect, useState } from 'react'
import { BeatLoader } from 'react-spinners'
import { getAccessToken } from 'reducers/authSlice'
import styled, { useTheme } from 'styled-components'

const Container = styled.div`
  width: 100%;
  border-radius: 6px;
  margin-bottom: 20px;
  position: relative;
  display: flex;
  flex-direction: column;
`

const SearchContainer = styled.div`
  width: 100%;
  z-index: 20;
  border: 1px solid #ccc;
  border-radius: 6px;
  background: #fff;
  padding: 25px 20px 20px;

  position: relative;
`

const SearchWrapper = styled.div`
  display: flex;
  align-items: center;
  background-color: #e6f6f8;
  border: 1px solid #9bd3dd;
  border-radius: 4px;
  padding: 6px 8px;
`

const SearchInput = styled.input`
  flex: 1;
  border: none;
  outline: none;
  font-size: 16px;
  background-color: #e6f6f8;
`

const ClearButton = styled.button`
  background: none;
  border: none;
  font-size: 18px;
  cursor: pointer;
  color: #666;
`
const CloseButton = styled.button`
  background: none;
  border: none;
  font-size: 15px;
  cursor: pointer;
  color: #666;
  position: absolute;
  top: 0px;
  right: 0px;
`

const DropdownList = styled.ul`
  z-index: 1000;
  list-style: none;
  margin: -20px 20px 20px;
  padding: 0;
  max-height: 200px;
  overflow-y: auto;
  background-color: #fff;
  border: 1px solid #ccc;
  border-radius: 4px;
`

const DropdownItem = styled.li`
  display: flex;
  padding: 8px;
  height: 40px;
  cursor: pointer;
  margin-top: auto;
  p {
    display: none;
  }
  &:hover {
    background: #e6f6f8;
    p {
      display: flex;
      margin-left: auto;
      font-size: 14px;
    }
  }
`

type Med = { tradeName: string; strength: string; gpi: string }
type SearchDropdownProps = {
  onSelect: (value: Med) => void
  onClose: () => void
}

function SearchDropdown({ onSelect, onClose }: SearchDropdownProps) {
  const [query, setQuery] = useState('')
  const token = useAppSelector(getAccessToken)
  const { getMedicationAutoCompleteInfo } = usePatientIntake({
    token: token!,
  })
  const theme = useTheme()

  const [nameOptions, setNameOptions] = useState<Med[]>([])

  useEffect(() => {
    if (query.length >= 4 && nameOptions.length === 0) {
      const getMeds = setTimeout(() => {
        getMedicationAutoCompleteInfo(query).then((res) => {
          setNameOptions(res.data.prescriptionMedications)
        })
      }, 1000)
      return () => clearTimeout(getMeds)
    } else if (query.length < 4) {
      setNameOptions([])
    }
  }, [query])

  const filteredOptions = nameOptions.filter((opt) => opt.tradeName.toLowerCase().includes(query.toLowerCase()))

  return (
    <Container>
      <SearchContainer>
        <CloseButton onClick={() => onClose()}>✕</CloseButton>
        <SearchWrapper>
          <Icon name="search" color="#98A4AE" styles={{ margin: 5 }} />
          <SearchInput placeholder="Search for a medication..." value={query} onChange={(e) => setQuery(e.target.value)} />
          {query && <ClearButton onClick={() => setQuery('')}>✕</ClearButton>}
        </SearchWrapper>
      </SearchContainer>

      {query && query.length >= 4 && (
        <>
          {nameOptions.length > 0 ? (
            <DropdownList>
              {filteredOptions.map((item, i) => (
                <DropdownItem key={i} onClick={() => onSelect(item)}>
                  {item.tradeName} <p>Press to select.</p>
                </DropdownItem>
              ))}
            </DropdownList>
          ) : (
            <BeatLoader size={10} color={theme.colors.primary1} />
          )}
        </>
      )}
    </Container>
  )
}

export default SearchDropdown
